import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react'
import { DATA_ROOM_ALLOWED_EXTENSIONS } from 'src/enviroment/constants/constants'

export const ACCEPT = DATA_ROOM_ALLOWED_EXTENSIONS.map((ext) => `.${ext}`).join(',')

export const SUPPORTED_FORMATS_LABEL = DATA_ROOM_ALLOWED_EXTENSIONS.map((ext) => ext.toUpperCase()).join(', ')

const handlePicked = (onPick: (files: File[]) => void) => (e: React.ChangeEvent<HTMLInputElement>) => {
  if (e.target.files) onPick(Array.from(e.target.files))
  // Cleared so picking the same file or folder again still fires change
  e.target.value = ''
}

export interface DataRoomFileDropzoneHandle {
  open: () => void
  openFolder: () => void
}

interface DataRoomFileDropzoneProps {
  onFiles: (files: File[]) => void
  onFolder: (files: File[]) => void
}

const DataRoomFileDropzone = forwardRef<DataRoomFileDropzoneHandle, DataRoomFileDropzoneProps>(
  ({ onFiles, onFolder }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null)
    const folderInputRef = useRef<HTMLInputElement>(null)

    // React's input props do not know `webkitdirectory`
    useEffect(() => folderInputRef.current?.setAttribute('webkitdirectory', ''), [])

    useImperativeHandle(ref, () => ({
      open: () => inputRef.current?.click(),
      openFolder: () => folderInputRef.current?.click(),
    }))

    const handleDragOver = (e: React.DragEvent) => {
      e.preventDefault()
      e.stopPropagation()
    }

    const handleDrop = (e: React.DragEvent) => {
      e.preventDefault()
      e.stopPropagation()
      onFiles(Array.from(e.dataTransfer.files))
    }

    return (
      <div className="contents" onDragOver={handleDragOver} onDrop={handleDrop}>
        <input
          ref={inputRef}
          type="file"
          className="hidden"
          multiple
          accept={ACCEPT}
          onChange={handlePicked(onFiles)}
        />
        <input ref={folderInputRef} type="file" className="hidden" onChange={handlePicked(onFolder)} />
      </div>
    )
  },
)

DataRoomFileDropzone.displayName = 'DataRoomFileDropzone'

export default DataRoomFileDropzone
